var map = {
	"./ic_btc_40.svg": 439,
	"./ic_dai_40.svg": 440,
	"./ic_eth_40.svg": 254,
	"./ic_frax_40.svg": 441,
	"./ic_link_40.svg": 442,
	"./ic_uni_40.svg": 443,
	"./ic_usdc_40.svg": 444,
	"./ic_usdt_40.svg": 445,
	"./ic_weth_40.svg": 446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 340;